
import { computed, defineComponent } from 'vue';
import { BOTTOM_POPUP_TYPES } from '@/types/enums';
import { useMainStore } from '@/store/mainStore';
import UploadFilesPopUp from './PopUpTypes/Upload/UploadFilesPopUp.vue';
import UploadPhotosPopUp from './PopUpTypes/Upload/UploadPhotosPopUp.vue';
import UploadAllPopUp from './PopUpTypes/Upload/UploadAllPopUp.vue';
import UploadFolderPopUp from './PopUpTypes/Upload/UploadFolderPopUp.vue';
// import UploadVideosPopUp from './PopUpTypes/Upload/UploadVideosPopUp.vue';
import MediaInfoPopUp from './PopUpTypes/MediaInfoPopUp.vue';
import MediaInfoOldPopUp from './PopUpTypes/MediaInfoOldPopUp.vue';
import CaseInfoPopUp from './PopUpTypes/CaseInfoPopUp.vue';
import CommentsPopUp from './PopUpTypes/CommentsPopUp.vue';
import UploadCasePopUp from './PopUpTypes/Upload/UploadCasePopUp.vue';

export default defineComponent({
  components: {
    UploadFilesPopUp,
    UploadPhotosPopUp,
    UploadAllPopUp,
    CommentsPopUp,
    MediaInfoPopUp,
    MediaInfoOldPopUp,
    CaseInfoPopUp,
    UploadFolderPopUp,
    UploadCasePopUp,
    // UploadVideosPopUp,
  },
  setup() {
    const mainStore = useMainStore();

    const isMediaInfo = computed(
      () => mainStore.BottomPopUpType === BOTTOM_POPUP_TYPES.PHOTO_INFO
        || mainStore.BottomPopUpType === BOTTOM_POPUP_TYPES.FILE_INFO,
    );

    const isMediaInfoOld = computed(
      () => mainStore.BottomPopUpType === BOTTOM_POPUP_TYPES.PHOTO_INFO_OLD
        || mainStore.BottomPopUpType === BOTTOM_POPUP_TYPES.FILE_INFO_OLD,
    );

    return {
      mainStore,
      isMediaInfo,
      isMediaInfoOld,
      CASE_BOTTOM_POPUP_TYPES: BOTTOM_POPUP_TYPES,
    };
  },
});
